import type { FC } from 'react';

import { cn } from '@/lib/utils';

import {
    LocalImage,
    type LocalImageProps,
} from '@/components/atoms/LocalImage';
import {
    ContentText,
    type ContentTextProps,
} from '@/components/molecules/ContentText';

import IntegrationSteps, {
    type IntegrationStepsProps,
} from './_components/IntegrationSteps';
import LinksList, { type LinksListProps } from './_components/LinksList';
import LogotypesExamples, {
    type LogotypeExampleUsageType,
} from './_components/LogotypesExamples';

export interface IntegrationContentTemplateProps {
    contentTextConfig: ContentTextProps;
    linksList?: LinksListProps['linksList'];
    productCardImage?: LocalImageProps;
    integrationSteps?: IntegrationStepsProps['integrationSteps'];
    logotypes?: LocalImageProps[];
    logotypeExampleUsage?: LogotypeExampleUsageType[];
}

const IntegrationContentTemplate: FC<IntegrationContentTemplateProps> = ({
    contentTextConfig,
    linksList,
    productCardImage,
    integrationSteps,
    logotypes,
    logotypeExampleUsage,
}) => (
    <div className="w-auto">
        <ContentText
            {...contentTextConfig}
            className={cn('text-left', contentTextConfig.className)}
        />

        {linksList && <LinksList linksList={linksList} />}

        {productCardImage && <LocalImage {...productCardImage} />}

        {integrationSteps && (
            <IntegrationSteps integrationSteps={integrationSteps} />
        )}

        {logotypes && (
            <LogotypesExamples
                logotypes={logotypes}
                logotypeExampleUsage={logotypeExampleUsage}
            />
        )}
    </div>
);
export default IntegrationContentTemplate;
